var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { markRaw, createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  width: "1.2em",
  height: "1.2em",
  viewBox: "0 0 16 16",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      d: "M12.862 2.19526C13.1224 1.93491 13.5445 1.93491 13.8049 2.19526C14.065 2.45557 14.065 2.87734 13.8049 3.13765L10.9426 5.99995H12.0002C12.3683 6.00004 12.6667 6.29832 12.6667 6.66645C12.6667 7.03459 12.3683 7.33287 12.0002 7.33296H9.3332C8.96509 7.33287 8.6667 7.03459 8.6667 6.66645V3.99995C8.6667 3.63181 8.96509 3.33305 9.3332 3.33296C9.70139 3.33296 10.0002 3.63176 10.0002 3.99995V5.05708L12.862 2.19526ZM7.3332 11.9999C7.33311 12.3681 7.03483 12.6665 6.6667 12.6665C6.29856 12.6665 6.00028 12.3681 6.00019 11.9999V10.9423L3.13789 13.8046C2.87758 14.0648 2.45581 14.0648 2.19551 13.8046C1.93516 13.5443 1.93516 13.1221 2.19551 12.8618L5.05732 9.99995H4.00019C3.632 9.99995 3.3332 9.70115 3.3332 9.33296C3.33329 8.96484 3.63206 8.66645 4.00019 8.66645H6.6667C7.03483 8.66645 7.33311 8.96484 7.3332 9.33296V11.9999Z",
      fill: "currentColor",
      "fill-opacity": "0.6157"
    }, null, -1)
  ]));
}
__name(render, "render");
const IconFullScreenExit = markRaw({ name: "custom-full-screen-exit", render });
export {
  IconFullScreenExit as default
};
//# sourceMappingURL=full-screen-exit.js.map
